import React from 'react';
import { shape, string } from 'prop-types';
import styles from './icon.module.css';

Icon.propTypes = {
  desc: shape({ src: string }),
};

export function Icon(props) {
  const { desc } = props;

  if (!desc.src) {
    return null;
  }

  // eslint-disable-next-line jsx-a11y/aria-role
  return <img role="icon" src={desc.src} alt="" className={styles.icon} />;
}
